import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  dumpTo: any;
  setDumpTo: (value: any) => void;
};

export const SelectDumpTo: React.FC<Props> = ({ setDumpTo }) => {
  const { t } = useTranslation();

  return (
    <FormControl sx={{ width: 300, mt: 2 }}>
      <FormLabel>{t('widgets.selectDumpTo.label')}</FormLabel>
      <RadioGroup defaultValue={"HOLDING_AREA"}>
        <FormControlLabel
          value="HOLDING_AREA"
          control={<Radio />}
          label={t('widgets.selectDumpTo.holdingArea')}
          onClick={() => setDumpTo("HOLDING_AREA")}
        />
        <FormControlLabel
          value="FRONT"
          control={<Radio />}
          label={t('widgets.selectDumpTo.frontOfHangar')}
          onClick={() => setDumpTo("FRONT")}
        />
      </RadioGroup>
    </FormControl>
  );
};
